import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/for-founders/FoundersClient.tsx");
